import "@/styles/globals.css";
import "@aws-amplify/ui-react/styles.css";

import { Amplify } from "aws-amplify";
import { Roboto } from "next/font/google";
import awsExports from "@/aws-exports";
import { withAuthenticator } from "@aws-amplify/ui-react";

const roboto = Roboto({ subsets: ["latin"], weight: ["400", "500", "700"] });

Amplify.configure({ ...awsExports, ssr: true });

function App({ Component, pageProps }) {
  return (
    <>
      <style jsx global>{`
        html {
          font-family: ${roboto.style.fontFamily};
        }
      `}</style>
      <Component {...pageProps} />
    </>
  );
}

export default withAuthenticator(App, { hideSignUp: true});
